export const CONTENTFUL_STORE_HOME_PAGE_ID = "6703gJhRGteRchXf3Djc0h"
